import { FontEntry } from '../../types/font'

export const raleway: FontEntry = {
  displayName: 'Raleway',
  weights: {},
  variables: {
    normal: {
      file: 'Raleway-VariableFont_wght',
      extension: 'ttf',
      format: 'truetype',
      weightRange: [100, 900]
    },
    italic: {
      file: 'Raleway-Italic-VariableFont_wght',
      extension: 'ttf',
      format: 'truetype',
      weightRange: [100, 900]
    }
  },
  fallbackMetrics: {
    arial: {
      regular: {
        sizeAdjust: 102.72,
        ascentOverride: 91.51,
        descentOverride: 22.78,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 99.72,
        ascentOverride: 94.27,
        descentOverride: 23.47,
        lineGapOverride: 0
      }
    },
    roboto: {
      regular: {
        sizeAdjust: 104.23,
        ascentOverride: 90.19,
        descentOverride: 22.45,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 105.64,
        ascentOverride: 88.98,
        descentOverride: 22.15,
        lineGapOverride: 0
      }
    }
  }
}
